import ArrowSelectIconDark from "components/Icons/ArrowSelectIconDark";
import { SelectBar } from "components/ui-component";
import { useCallback, useEffect } from "react";
import { useAppDispatch } from "redux/hooks";
import { setNumber, useNumber } from "redux/slice/commanSlice";
import { useNumberDetails, useUserDetails } from "redux/slice/faxSlice";

const SelectNumber = () => {
  const dispatch = useAppDispatch();
  const userDetails = useUserDetails();
  const numberDetails = useNumberDetails();
  const number = useNumber();

  const numberOptions = useCallback(() => {
    const data = userDetails?.assigned_number ?? [];
    const options = data?.map((x: string) => ({ value: x, label: x }));
    return options;
  }, [userDetails]);

  useEffect(() => {
    const options = numberOptions();
    if (!number && options.length > 0) {
      dispatch(setNumber(options[0].value));
    }
  }, [userDetails, number, dispatch, numberOptions]);

  return (
    <>
      <div className="form-group">
        <label htmlFor="timezone">Select Number</label>
        <SelectBar
          suffixIcon={<ArrowSelectIconDark />}
          showSearch
          optionFilterProp="label"
          options={numberOptions() ?? []}
          value={number}
          onChange={(value: string) => dispatch(setNumber(value))}
        />
      </div>
      <div className="usage">
        <span className="title">This Month's Usage</span>
        <span className="value">
          {numberDetails?.total_pages ?? 0}&nbsp;/&nbsp;
          {numberDetails?.license_page_limit ?? 0}
          &nbsp;Pages
        </span>
      </div>
    </>
  );
};

export default SelectNumber;
